export default {
    name: 'CaseCard',
    setup() {}
}
